module.exports = __webpack_public_path__ + "static/media/question.0a11c0c8.svg";